export default {
  transfers: [],
  pagination: {},
  transfer: {}
}
